import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { sendApiRequest } from "../utils/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { FaChevronRight, FaFolderOpen, FaRegCheckCircle  } from "react-icons/fa";
import LogoLoader from "./LogoLoader";
import Logo from "../assets/logo2.jpeg";


const ViewDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [exam, setExam] = useState(null);
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchData = async () => {
      try {
        const examRes = await sendApiRequest(
          `api/admin/exams/${id}`,
          {},
          "GET"
        );
        setExam(examRes);

        const topicRes = await sendApiRequest(
          `api/admin/topics/exam/${id}`,
          {},
          "GET"
        );
        setTopics(topicRes?.data || []);
      } catch (err) {
        toast.error("Failed to load details");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleTopicClick = (topic) => {
    if (!user) {
      toast.info("Please login to continue");
      navigate("/login");
      return;
    }

    if (topic.isPaid) {
      navigate(`/payment/${topic._id}`);
    } else {
      navigate(`/topic/${topic._id}`);
    }
  };

  if (loading) {
    return (
      <div className="bg-[#1d3a80] min-h-screen font-[montserrat]">
        <LogoLoader text="Loading exam details..." />
      </div>
    );
  }

  if (!exam) {
    return <div className="py-20 text-center text-gray-500">Not found</div>;
  }

  return (
    <div className="bg-[#1d3a80] min-h-screen font-[montserrat] ">

      {/* ================= HEADER ================= */}
      <div className="px-2 py-3">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center text-white">

          {/* Logo */}
          <div className="w-28 h-28 rounded-full bg-white flex items-center justify-center shadow">
            <img
              src={Logo}
              alt="Logo"
              className="w-20 h-20 object-contain"
            />
          </div>

          {/* Text Content */}
          <div>
            <h1 className="text-xl font-bold">
              Shorthand Software Academy
            </h1>
            <p className="text-sm text-white/90 ">
              shorthandsoftwareacademy@gmail.com
            </p>
            <p className="text-sm text-white/90">
              +91 87872 24408
            </p>
          </div>

        </div>
      </div>


      {/* ================= CONTENT ================= */}
      <div className="bg-[#f5f7fb] rounded-t-3xl px-4 py-6 max-w-3xl mx-auto">

        {/* COURSE INFO */}
        <div className="mb-6">
          <h2 className="text-lg font-semibold text-gray-900">
            {exam.name}
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            {exam.description}
          </p>
          <p className="text-sm text-[#1f4fa3] font-medium mt-2">
            ₹ {exam.fee} • {exam.timingPeriod} Days
          </p>
        </div>

        {/* TOPICS LIST */}
        <h3 className="text-base font-semibold text-gray-800 mb-3">
          Practice Topics
        </h3>

        {topics.length > 0 ? (
          topics.map((topic, index) => (
            <div
              key={topic._id}
              onClick={() => handleTopicClick(topic)}
              className="flex items-center gap-4 bg-[#1d3a80] rounded-xl p-4 mb-3
                         shadow-sm hover:shadow-md transition cursor-pointer"
            >
              {/* INDEX */}
              {/* ICON */}
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                <FaFolderOpen className="text-white" size={36} />
              </div>


              {/* INFO */}
              <div className="flex-1">
                <h4 className="text-lg font-bold text-white">
                  {topic.title}
                </h4>
                <p className="text-xs text-white display flex items-center gap-2">
                  <FaRegCheckCircle  className="text-white" size={16} /> All Speed
                </p>
                <p
                  className={`text-xs font-medium mt-0.5 ${topic.isPaid ? "text-red-500" : "text-green-600"
                    }`}
                >
                  {topic.isPaid ? "Paid Topic" : "Free Topic"}
                </p>
              </div>

              {/* ARROW */}
              <FaChevronRight className="text-gray-400 text-sm" />
            </div>
          ))
        ) : (
          <div className="text-center text-gray-500 py-10">
            Topics coming soon
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewDetails;
